module.exports = __webpack_public_path__ + "img/img_uniform_price.be2004bf.jpg";